import { call, put, takeLatest } from "redux-saga/effects";
import { ILogin, IVerifyOtp } from "../../../types/authTypes";
import { loginUser, userMe, verifyOtp } from "../../actions/authActions";
import {
  loginRequestApi,
  userMeApi,
  verifyOtpApi,
} from "../requests/authRequests";
import toast from "react-hot-toast";
import {
  AuthFormState,
  setAuthFormState,
} from "../../slices/feature/tempSlice";
import { setAuthStatus, setUserProfile } from "../../slices/feature/userSlice";
import { setLoader } from "../../slices/feature/loader/loaderSlice";

interface loginActionInterface {
  type: string;
  payload: ILogin;
}
interface verifyOtpInterface {
  type: string;
  payload: IVerifyOtp;
}

function* loginUserHandler(action: loginActionInterface): any {
  try {
    const { data } = yield call(loginRequestApi, action.payload);
    console.log("data", data);

    if (data) {
      yield localStorage.setItem("otp-token", data?.token);
      yield put(setAuthFormState(AuthFormState.OtpSent));
      // yield put(setAuthStatus(true))
      // yield (api.defaults.headers.common = {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      // });
      toast.success(data?.message, { duration: 2000 });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}
function* verifyOtpHandler(action: verifyOtpInterface): any {
  try {
    const { data } = yield call(verifyOtpApi, action.payload);
    console.log("data", data);

    if (data.isSuccess) {
      yield localStorage.setItem("token", data?.token);
      // yield put(setAuthFormState(AuthFormState.OtpSent));
      yield put(setAuthStatus(true));
      yield getUserMeHandler();
      // yield (api.defaults.headers.common = {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      // });
      toast.success(data?.message, { duration: 2000 });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}
function* getUserMeHandler(): any {
  try {
    const { data } = yield call(userMeApi);

    yield put(setUserProfile(data));
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}
export default function* authSaga() {
  yield takeLatest(loginUser.type, loginUserHandler);
  yield takeLatest(verifyOtp.type, verifyOtpHandler);
  yield takeLatest(userMe.type, getUserMeHandler);
}
